import React, { useEffect } from 'react';
import contract from '../../assets/contract.png';
import contract_new from '../../assets/contract_new.png';
import close from '../../assets/close.svg';

const Contract = React.memo(({ simObj, setSimObj, updateReadStatus, closePopups, replaceVariables, popupLeft, addSpaceAfterDot }) => {
  useEffect(() => {
    window.jQuery('.item').tab();
    if (document.querySelector(".contract-box .ui.list .tab-item.active")) {
      document.querySelector(".contract-box .ui.list .tab-item.active").click();
    }
  }, []);
  useEffect(() => {
      const ua = navigator.userAgent;
      // Detect iOS devices (including iPadOS that reports as Mac)
      const isIOS =
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  
      // Detect Android tablets (Android but not phones)
      const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);
      
      if (isIOS || isAndroidTablet) {
        const popupBox = document.querySelector(
          '.ui.raised.popup-box'
        );
  
        if (popupBox) {
          popupBox.setAttribute('tabindex', '-1'); // 👈 make it focusable
        } 
  
        const dialog = document.querySelector('.contract-box .popup-box[role="dialog"]');
        setTimeout(() => {
          if (dialog) {
            dialog.focus();
          }
        }, 1000);
      }
    }, []);
  // useEffect(() => {
  //   document.querySelector(".popup-container .header-box h2").tabIndex = -1;
  //   document.querySelector(".popup-container .header-box h2").focus();
  // }, [])
  return (
    <div className='ui pointing label popup-container contract-box' style={{ "--left": `${popupLeft}px` }}>
      {/* <div className="polygon email"></div> */}
      <div className="ui raised very padded text container segment popup-box" role="dialog" aria-modal="true" aria-labelledby="contractModal">
        <div className="header-box">
          <div>
            <img className="image textmsg icon" src={contract_new} alt="" />
            <h2 id="contractModal" className="title" tabIndex={-1}>CONTRACT</h2>
          </div>
          <div className='close-popup' onClick={closePopups}>
            <a role="button" href="#" aria-label='Close'><img src={close} alt="" /></a>
          </div>
        </div>
        <div className="section">
          {
            simObj?.artifacts?.filter((data) => data.md == "CONTRACT").length > 0 ?
              (<div className="ui stackable two column grid">
                <div className="six wide column">
                  <div className="ui secondary segment">
                    <ul className="ui divided list" role="tablist" aria-label="Contract tabs">
                      {simObj.artifacts.filter((data) => data.md == "CONTRACT").sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).map((data, index) => (
                        <li id={data.aii} key={data.aii} className={`item tab-item ${(index == 0) || (data.ci == data.aii) ? 'active' : ''} ${data.rs == 1 ? 'visited' : ''}`} data-tab={"tab-" + data.aii} onClick={updateReadStatus} role='tab' onKeyDown={(e) => e.key == "Enter" && e.currentTarget.click()} tabIndex={index == 0 ? 0 :-1}  aria-selected={index==0} aria-controls={`tab_${data.aii}_tab`}>
                          <div className="content">
                            <p>
                              <span className="sr-only">
                                {data.rs==1 ? "Visited:" : "Not Visited:"}
                              </span>
                              <p>
                                <a></a>
                                <span className="left floated">{data.val.artifactName == '' ? "No Subject" : data.val.artifactName}</span>
                                <span className="right floated" style={{ minWidth: "50px", textAlign: "end" }}></span>
                              </p>
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="ten wide column" tabIndex={-1}>
                  <div>
                  {simObj.artifacts.filter((data) => data.md == "CONTRACT").sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).map((data, index) => (
                      <div className={`ui tab ${index == 0 ? "active" : ""}`} key={data.aii} data-tab={"tab-" + data.aii} id={`tab_${data.aii}_tab`} role="tabpanel" aria-labelledby={data.aii} tabIndex={index==0 ? 0 : -1} hidden>
                        <div className="content_box">
                          {/* <div className="subject_box">
                            <p>FROM: <span>{data.value.sender}</span></p>
                            <p>SUBJECT: <span>{data.value.artifactName}</span></p>
                          </div> */}
                          <div className="compose_box" dangerouslySetInnerHTML={{ __html: replaceVariables(addSpaceAfterDot(data.val.value)) }}>

                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>)
              :
              (<div className='empty ui stackable grid'>
                <div className="column">
                  <div className="ui info message">
                    <div className="header">
                      There are no contract for this category.
                    </div>
                  </div>
                </div>
              </div>)
          }
        </div>
      </div>
    </div>
  )
})

export default Contract